import { FC } from 'react';
import { Card } from '@mofid-securities/uikit';
import { HorizontalPaddingLayout } from '@/layouts/HorizontalPadding';
import { Divider } from '@/components/Divider';
import { Header } from './components/Header';
import { Writer } from './components/Writer';
import { useFlag } from '@/unleash';
import { useFindFundByQuery } from '@/modules/invest/subModules/fund/hooks/useFindFund';

const AIAnalysis: FC = () => {
  const { isEnabled } = useFlag('web.fund.aiSummerize');
  const { fund } = useFindFundByQuery();

  if (!isEnabled || !fund?.showAiData) {
    return null;
  }

  return (
    <>
      <HorizontalPaddingLayout className="py-4">
        <Card
          className="border-1 border border-gray-solid-primary-enabled"
          padding={16}
          radius="md"
        >
          <Header />
          <Writer />
        </Card>
      </HorizontalPaddingLayout>
      <Divider height={8} />
    </>
  );
};

export { AIAnalysis };
